import React from 'react';
import PropTypes from 'prop-types';
import {TableCell, TableRow, TextField, Checkbox, TableSortLabel} from '@material-ui/core';
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";


function EnhancedTableHead(props) {
    const { columns, classes, order, orderBy, onRequestSort, filtros, DetailByrow, cambioSelccionAll, dataf, isSeleccionable, cambioCampo, accionesFila, usarEstilosTablero } = props;
    let classesTablero = useStylesTablero();
    if (!usarEstilosTablero)
      classesTablero = {};
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
    return (
        // <TableRow>
        <React.Fragment>
          {/* {isSeleccionable &&
            <TableCell padding="checkbox" >
              <Checkbox
                indeterminate={dataf.some(row => row.isSelecciondo) && !dataf.every(row => row.isSelecciondo == true)}
                checked={dataf.every(row => row.isSelecciondo == true)}
                onChange={cambioSelccionAll}
              />
            </TableCell>
          } */}
          {
            DetailByrow != null &&
            <TableCell  className={classes?.background} padding="checkbox" />
          }
          {columns.map((column, ncolumna) => (
            <TableCell className={usarEstilosTablero ? classesTablero.tablaCelda : classes?.background} key={'header' + column.name} padding={column.disablePadding ? "none" : "default"} sortDirection={orderBy === column.name ? order : false}>
                <div style={{display:'inline-flex'}}>
                  {!column.filtrar ?
                      column.label
                      : typeof column.filtrar !== 'object' ?
                      <TextField
                          fullWidth size="small" label={column.label}
                          onChange={cambioCampo(column.name)}
                          value={filtros != null ? filtros[column.name] : null}
                          // style={{ minWidth: (filtros.espesificos[column.name]?.length || column.label.length) + 'rem' , fontSize: 8 }}
                          style={{ minWidth: column.label.length+ 'rem' }}
                          //style={{ minWidth: (column.tamano ? column.tamano : (filtros !=null ? filtros[column.name]?.length : column.label.length))  + 'rem' }}

      
                      />
                      : <TextField
                          select fullWidth size="small" label={column.label}
                          onChange={cambioCampo(column.name)}
                          SelectProps={{ native: true, }}
                          style={{ minWidth: column.label.length+ 'rem'}}
                          //style={{ minWidth: (filtros[column.name]?.length || column.label.length) + 'rem' }}
                      >
                          <option></option>
                          {column.filtrar.ctl.map((opcion, index) =>
                          <option key={index}>
                              {opcion[column.filtrar.value]}
                          </option>
                          )}
                      </TextField>
                  }
                  <TableSortLabel
                    active={orderBy === column.name}
                    direction={orderBy === column.name ? order : "asc"}
                    onClick={createSortHandler(column.name)}
                    // style={{ minWidth:'4em' }}
                  >
                  </TableSortLabel>
                </div>
            </TableCell>
          ))}
          {
            accionesFila.length > 0 &&
            <TableCell className={classes?.background} padding="checkbox" />
          } 
          </React.Fragment>
        // </TableRow> 
    );
  };
  
  EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  export default EnhancedTableHead;